/**
 * Het woord dat je intypt om de plek van je taal over te nemen. In ELKE taal
 * hetzelfde, want de uitleg noemt het letterlijk. Zie components/PlekBezet.tsx.
 */
export const WISSELWOORD = 'WISSEL';

/** Hoofdletters, spaties en een punt achteraan maken niet uit. */
export function isWisselwoord(invoer: string): boolean {
  return invoer.trim().replace(/[.!]+$/, '').toUpperCase() === WISSELWOORD;
}
